// src/features/projectsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    list: [],
    status: 'idle',
    error: null
  },
  reducers: {
    setProjects: (state, action) => {
      console.log('Setting projects in slice:', action.payload);
      state.list = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = 'failed';
    },
    clearProjects: (state) => {
      state.list = [];
      state.status = 'idle';
      state.error = null;
    }
  }
});

export const { setProjects, setError, clearProjects } = projectsSlice.actions;

export const selectAllProjects = (state) => {
  console.log('Selecting projects:', state.projects.list);
  return state.projects.list;
};
export const selectProjectsStatus = (state) => state.projects.status;
export const selectProjectsError = (state) => state.projects.error;

export default projectsSlice.reducer;